<div class="main-content">
  <ov-suite-hierarchy-tabs [tabs]="tabs"> </ov-suite-hierarchy-tabs>
  <div class="main-container">
  <ov-suite-hierarchy-table
    [title]="'Inventory by SKU'"
    [formClass]="formClass"
    [hasBulkUpload]="false"
    [excludeColumns]="4"
    [hideAddButton]="true"
  >
  </ov-suite-hierarchy-table>
  </div>
</div>
